import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport2010Status: 'idle',
    startReport2010Error: undefined as any,
    loadUserParamsReport2010Status: 'idle',
    loadUserParamsReport2010Error: undefined as any,

    report2010List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport2010 = createAsyncThunk('report2010Slice/startReport2010', async ({ report2010 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport2010/`,
        prepareData(report2010),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport2010Status } = getState().report2010Slice
        return startReport2010Status !== 'pending'
    }
})

export const loadUserParamsReport2010 = createAsyncThunk('report2010Slice/loadUserParamsReport2010', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport2010/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport2010Status } = getState().report2010Slice
        return loadUserParamsReport2010Status !== 'pending'
    }
})

const Report2010Slice = createSlice({
    name: 'report2010Slice',
    initialState,
    reducers: {
        resetstartReport2010: (state) => {
            state.job = undefined
            state.startReport2010Error = undefined
        },
        resetstartReport2010Error: (state) => {
            state.startReport2010Error = undefined
        },
        resetloadUserParamsReport2010: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport2010Error = undefined
        },
        resetloadUserParamsReport2010Error: (state) => {
            state.loadUserParamsReport2010Error = undefined
        },
        removeFromReport2010ListById: (state, action) => {
            state.report2010List = state.report2010List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport2010ListByIds: (state, action) => {
            state.report2010List = state.report2010List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report2010List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport2010Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report2010List = []
            state.startReport2010Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport2010.pending, (state) => {
            state.startReport2010Status = 'pending'
            state.startReport2010Error = undefined
        })
        builder.addCase(startReport2010.fulfilled, (state, action) => {
            state.startReport2010Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport2010.rejected, (state, action) => {
            state.startReport2010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport2010Error = action.error.message
            } else {
                state.startReport2010Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport2010.pending, (state) => {
            state.loadUserParamsReport2010Status = 'pending'
            state.loadUserParamsReport2010Error = undefined
        })
        builder.addCase(loadUserParamsReport2010.fulfilled, (state, action) => {
            state.loadUserParamsReport2010Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport2010.rejected, (state, action) => {
            state.loadUserParamsReport2010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport2010Error = action.error.message
            } else {
                state.loadUserParamsReport2010Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport2010,
    resetstartReport2010Error,
    resetloadUserParamsReport2010,
    resetloadUserParamsReport2010Error,
    removeFromReport2010ListById,
    removeFromReport2010ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report2010Slice.actions
export default Report2010Slice.reducer
